import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

// Array de imágenes locales de mariscos (descargadas en /public/images/seafood/)
const seafoodImages = [
  "/images/seafood/pulpo1.jpg",
  "/images/seafood/pulpo2.jpg",
  "/images/seafood/pulpo3.jpg",
  "/images/seafood/camaron1.jpg",
  "/images/seafood/camaron2.jpg",
  "/images/seafood/pargo1.jpg",
  "/images/seafood/langosta1.jpg",
  "/images/seafood/langosta2.jpg",
  "/images/seafood/langosta3.jpg",
];

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [backgroundImage, setBackgroundImage] = useState(seafoodImages[0]);
  const { login } = useAuth();
  const navigate = useNavigate();

  // Seleccionar imagen aleatoria al cargar
  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * seafoodImages.length);
    setBackgroundImage(seafoodImages[randomIndex]);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Sesión iniciada correctamente");
      navigate("/dashboard");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Left side - Image */}
      <div
        className="hidden lg:flex lg:w-1/2 bg-cover bg-center relative"
        style={{
          backgroundImage: `url('${backgroundImage}')`,
        }}
      >
        <div className="absolute inset-0 bg-slate-900/60" />
        <div className="relative z-10 flex flex-col justify-end p-12 text-white">
          <h2 className="text-4xl font-bold mb-4">Sistema de Gestión Documental</h2>
          <p className="text-lg text-slate-300 max-w-md">
            Control completo de envíos de pescado congelado. Del caribe a tu mesa. Lotes, trazabilidad, documentación y logística en un solo lugar.
          </p>
          <p className="text-2xl font-semibold text-white/90 mt-6 italic">
            Del mar a tu mesa
          </p>
        </div>
      </div>

      {/* Right side - Form */}
      <div className="flex-1 flex items-center justify-center p-8 bg-slate-50">
        <div className="w-full max-w-md">
          <div className="mb-8">
            <h1 className="text-2xl font-bold text-slate-900">Premium Fish - gestión documental</h1>
          </div>

          <Card className="border-slate-200 shadow-none">
            <CardHeader className="pb-4">
              <CardTitle className="text-xl">Iniciar Sesión</CardTitle>
              <CardDescription>Ingresa tus credenciales para acceder</CardDescription>
            </CardHeader>
            <CardContent>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="email">Usuario</Label>
                  <Input
                    id="email"
                    type="text"
                    placeholder="Usuario"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    data-testid="login-email"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="password">Contraseña</Label>
                  <Input
                    id="password"
                    type="password"
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    data-testid="login-password"
                  />
                </div>
                <Button
                  type="submit"
                  className="w-full bg-slate-900 hover:bg-slate-800"
                  disabled={loading}
                  data-testid="login-submit"
                >
                  {loading ? (
                    <>
                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                      Iniciando...
                    </>
                  ) : (
                    "Iniciar Sesión"
                  )}
                </Button>
              </form>
              <p className="text-center text-xs text-slate-400 mt-6">
                Contacte al administrador para obtener acceso
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
